function updateScrollHeader(header, headerLogo) {
    const scrolledHeader = 'scrolled';
    const headerScrolled = Math.min(header.clientHeight, window.scrollY);

    if (window.innerWidth >= 768 && headerScrolled >= 80) {
        header.classList.add(scrolledHeader);
    }
    else {
        header.classList.remove(scrolledHeader);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector('header');

    if (header !== null) {
        document.addEventListener('scroll', () => {
            updateScrollHeader(header);
        }, {
            passive: true
        });
        updateScrollHeader(header);
    }
});
